import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styles from "./AIFootnoteTip.module.less";
import IconFont from "@/components/icon";
import { usePrevious } from "@/utils/chat/index";
import { canJoyspacePreview } from "@/components/Joyspace/util";
import { preivewFileWPS } from "@/utils/chat/message";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { getJoySpacePageLink } from "@jd/focus-desktop-comps/lib/es/utils";

interface IProps {
  dataInfo: Record<string, any>;
  visible: boolean;
  customStyle?: any;
  handleClose: Function;
  handleEnter: Function;
}
function AiFootnoteTip(props: IProps) {
  const { dataInfo, visible, customStyle, handleEnter, handleClose } = props;
  const wrapRef = useRef<any>();
  const preVisible = usePrevious(visible);
  const [currentHeight, setCurrentHeight] = useState<number>(0);
  const [currentWidth, setCurrentWidth] = useState<number>(0);
  const { appRuntimeEnv } = React.useContext<GlobalContextConfig>(GlobalContext);

  const {
    fileService: { imAppKey },
    joyspaceHost,
    joyspaceApiHost
  } = appRuntimeEnv;

  const handleItemClick = useCallback(() => {
    const { pageUrl, fileType, fileKey, filename } = dataInfo;
    if (Number(fileType) === 2) {
      if (canJoyspacePreview(filename)) {
        preivewFileWPS({ appKey: imAppKey, downloadUrl: pageUrl }, { joyspaceHost });
      }
      return;
    }
    if (fileKey && fileType) {
      // 打开文档
      window.open(
        getJoySpacePageLink(joyspaceHost, {
          pageType: fileType,
          id: fileKey
        })
      );
      return;
    }
    if (pageUrl) {
      // 直接打开
      window.open(pageUrl);
    }
  }, [dataInfo, imAppKey, joyspaceHost]);

  const calculateHeight = () => {
    const height = wrapRef.current?.offsetHeight;
    const width = wrapRef.current?.offsetWidth;
    setCurrentHeight(height);
    setCurrentWidth(width);
  };

  const calculateStyle = useMemo(() => {
    const top = Math.max(30, (customStyle?.top || 0) - currentHeight - 8);
    let left = Math.max(8, (customStyle?.left || 0) - currentWidth / 2);
    const diffWidth = window.innerWidth - 10 - (left + currentWidth);
    left = diffWidth < 0 ? left + diffWidth : left;
    return {
      ...customStyle,
      top,
      left
    };
  }, [currentHeight, currentWidth, customStyle]);
  useEffect(() => {
    // 1. 计算高度
    if (!preVisible && visible) {
      calculateHeight();
    }
  }, [visible, preVisible]);
  return (
    <div
      ref={wrapRef}
      className={`${styles["ai-footnote-tip-wrap"]} ${!visible ? styles["dn"] : ""}`}
      style={calculateStyle}
      onClick={handleItemClick}
      onMouseEnter={() => handleEnter?.()}
      onMouseLeave={() => handleClose?.()}
    >
      <span className={styles["title"]}>引用来源</span>
      <div className={styles["content"]}>{dataInfo?.content}</div>
      <div className={styles["link-wrap"]}>
        <div className={`${styles["item"]} two-lines`}>
          <IconFont className={styles["icon"]} type="iconapp_ic_bardoc" />
          <span className={styles["text"]}>{dataInfo?.source}</span>
        </div>
      </div>
    </div>
  );
}

export default React.forwardRef(AiFootnoteTip);
